import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
	deviceId: '',
	authorization: ''
}

const mutations = {
	pracedeviceId (state, params) {
		state.deviceId = params
	},
	praceauthorization (state, params) {
		state.authorization = params
	}
}

const actions = {
	getdeviceId (context, params) {
		context.commit('pracedeviceId', params)
	},
	getauthorization (context, params) {
		context.commit('praceauthorization', params)
	}
}

// 创建管理全局状态的对象
// store
const store = new Vuex.Store({
	// 配置全局状态
	state,
	mutations,
	actions
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js